export const constants = {
  authenticatedKey: 'Ai-Call',
  orgName: 'SynergenHealth',
  lastCallIdKey: 'lastCallId',
  recentFileUploadKey: 'recentFiles',
  lastCallStatusKey: 'lastCallStatus',
  itemsPerPage: 10,
  storageKeys: {
    codeVerifier: 'codeVerifier',
    codeChallenge: 'codeChallenge',
    requestId: 'requestId',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    codeValue: 'code_val',
    stateValue: 'state_val',
    sessionId: 'sessionId',
    expiresIn: 'expiresIn',
    accessTokenLastUpdatedAt: 'accessTokenLastUpdatedAt',
    screenPermission: 'screenFeature'
  },
};

export const dateFormats = {
  DATE_TIME: 'yyyy-MM-dd hh:mm a',
  US_SHORT_MON_DATE: 'MMM dd, yyyy hh:mm a',
};

export const twilioNumber = '+15092107876';

export const regex = {
  email: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
};


export const DateRangePresets = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 Days', value: 'last7Days' },
  { label: 'Last 30 Days', value: 'last30Days' },
  { label: 'Last Month', value: 'lastMonth' },
];
